import {
  GET_DOCUMENT_DETAIL,
  UPLOAD_DOCUMENT,
  UPDATE_DOCUMENT_STATUS,
} from "./constants";

export const getAllDocuments = (id) => {
  return {
    type: GET_DOCUMENT_DETAIL,
    id,
  };
};

export const uploadDocument = (payload, typeId) => {
  return {
    type: UPLOAD_DOCUMENT,
    payload,
    typeId,
  };
};

export const updateDocumentStatus = (payload) => {
  return {
    type: UPDATE_DOCUMENT_STATUS,
    payload,
  };
};
